<template>
  <v-container fluid>
    <v-row dense>
      <v-col>
        <v-card elevation="24" outlined shaped>
          <v-toolbar height="25px" dark color="#96298A">
            <v-toolbar-title>Origen</v-toolbar-title>
          </v-toolbar>
          <v-card-text class="pt-0">
            <v-row dense>
              <v-col>
                <v-combobox
                  v-model="paisRemitente"
                  :items="paises"
                  item-text="nombre"
                  item-value="iso"
                  label="País"
                  :rules="[reglas.requeridoCbx]"
                  required
                  prepend-icon="map"
                  return-object
                  hide-details
                />
              </v-col>
            </v-row>
            <v-row dense>
              <v-col>
                <v-text-field
                  v-model="ciudad_e"
                  label="Ciudad"
                  required
                  :rules="[reglas.requeridoTxt, reglas.largo(35)]"
                  :counter="35"
                  prepend-icon="place"
                  hide-details
                />
              </v-col>
            </v-row>
            <v-row dense>
              <v-col>
                <v-text-field
                  v-model="zip_e"
                  :rules="[reglas.largo(12)]"
                  :counter="12"
                  label="Codigo Postal"
                  prepend-icon="near_me"
                  hide-details
                />
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col>
        <v-card elevation="24" outlined shaped>
          <v-toolbar height="25px" dark color="#96298A">
            <v-toolbar-title>Destino</v-toolbar-title>
          </v-toolbar>
          <v-card-text class="pt-0">
            <v-row dense>
              <v-col>
                <v-combobox
                  v-model="paisDestino"
                  :items="paises"
                  item-text="nombre"
                  item-value="iso"
                  label="País"
                  :rules="[reglas.requeridoCbx]"
                  required
                  prepend-icon="map"
                  return-object
                  hide-details
                />
              </v-col>
            </v-row>
            <v-row dense>
              <v-col>
                <v-text-field
                  v-model="ciudad_c"
                  label="Ciudad"
                  required
                  :rules="[reglas.requeridoTxt, reglas.largo(35)]"
                  :counter="35"
                  prepend-icon="place"
                  hide-details
                />
              </v-col>
            </v-row>
            <v-row dense>
              <v-col>
                <v-text-field
                  v-model="zip_c"
                  :rules="[reglas.largo(12)]"
                  :counter="12"
                  label="Codigo Postal"
                  prepend-icon="near_me"
                  hide-details
                />
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col>
        <v-card elevation="24" outlined shaped>
          <v-toolbar height="25px" dark color="#96298A">
            <v-toolbar-title>Información de Envío</v-toolbar-title>
          </v-toolbar>
          <v-card-text class="pt-0">
            <v-row dense>
              <v-col>
                <v-combobox
                  v-model="tipo"
                  :items="tipos"
                  item-text="tipo"
                  item-value="tipo"
                  label="Tipo"
                  :rules="[reglas.requeridoCbx]"
                  required
                  prepend-icon="checklist"
                  return-object
                  hide-details
                />
              </v-col>
            </v-row>
            <v-row dense>
              <v-col>
                <v-text-field
                  v-model="valor"
                  label="Valor Declarado"
                  required
                  type="number"
                  :rules="[reglas.requeridoTxt]"
                  prepend-icon="paid"
                  hide-details
                />
              </v-col>
            </v-row>
            <!--v-row dense>
              <v-col>
                <v-combobox
                  v-model="moneda"
                  :items="monedas"
                  item-text="moneda"
                  item-value="moneda"
                  label="Moneda"
                  :rules="[reglas.requeridoCbx]"
                  required
                  prepend-icon="monetization_on"
                  return-object
                  hide-details
                />
              </v-col>
            </v-row-->
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row dense>
      <v-card elevation="24" outlined shaped>
        <v-toolbar height="25px" dark color="#96298A">
          <v-toolbar-title>Paquetes</v-toolbar-title>
        </v-toolbar>
        <v-card-text class="pt-0">
          <v-row dense>
            <!--v-col>
              <v-combobox
                v-model="unidadPesoPaq"
                :items="optUnidadPesoPaq"
                item-text="unidad_peso"
                item-value="descripcion"
                label="Unidad Peso"
                auto-select-first
                prepend-icon="scale"
                return-object
                hide-details
              />
            </v-col-->
            <!--v-col>
              <v-combobox
                v-model="uMPaq"
                :items="optUMPaq"
                item-text="unidad_medida"
                item-value="descripcion"
                label="Unidad Medida"
                auto-select-first
                prepend-icon="straighten"
                return-object
                hide-details
              />
            </v-col-->
            <v-col>
              <v-text-field
                ref="piezaspaquete"
                v-model="paquete.piezas"
                label="Piezas"
                type="number"
                prepend-icon="calculate"
                step="1"
                min="1"
                @change="calcularPesoTotalPaquete()"
                hide-details
              />
            </v-col>
            <v-col>
              <v-text-field
                v-model="paquete.peso"
                label="Peso KGS"
                type="number"
                prepend-icon="calculate"
                step="any"
                min="1"
                @change="calcularPesoTotalPaquete()"
                hide-details
              />
            </v-col>
            <v-col>
              <v-text-field
                v-model="paquete.pesototal"
                label="Peso Total KGS"
                type="number"
                readonly
                disabled
                prepend-icon="calculate"
                hide-details
              />
            </v-col>
            <v-col>
              <v-text-field
                v-model="paquete.largo"
                label="Largo CM"
                type="number"
                prepend-icon="calculate"
                step="1"
                min="0"
                @change="calcularVolumenTotalPaquete()"
                hide-details
              />
            </v-col>
            <v-col>
              <v-text-field
                v-model="paquete.ancho"
                label="Ancho CM"
                type="number"
                prepend-icon="calculate"
                step=""
                min="0"
                @change="calcularVolumenTotalPaquete()"
                hide-details
              />
            </v-col>
            <v-col>
              <v-text-field
                v-model="paquete.alto"
                label="Alto CM"
                type="number"
                prepend-icon="calculate"
                step="1"
                min="1"
                @change="calcularVolumenTotalPaquete()"
                hide-details
              />
            </v-col>
            <v-col>
              <v-text-field
                v-model="paquete.volumentotal"
                label="Volumen Total"
                type="number"
                readonly
                disabled
                prepend-icon="calculate"
                hide-details
              />
            </v-col>
            <v-col>
              <v-btn color="blue darken-1" dark @click="addPaquete(paquete)">
                <v-icon dark> mdi-plus </v-icon>
              </v-btn>
            </v-col>
          </v-row>
          <v-divider class="pa-1"></v-divider>
          <v-row dense>
            <v-col>
              <v-data-table
                :headers="headersPaquetes"
                :items="paquetes"
                class="elevation-1"
              >
                <template v-slot:item.acciones="{ item }">
                  <v-btn icon color="red" @click="deletePaquete(item)">
                    <v-icon>mdi-delete</v-icon>
                  </v-btn>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
          <v-row dense>
            <div>Piezas: </div>{{ piezas }}<v-divider vertical class="mx-2"></v-divider>
            <div>Peso Total: </div>{{ peso }}<v-divider vertical class="mx-2"></v-divider>
            <div>Volumen Total: </div>{{ volumen }}<v-divider vertical class="mx-2"></v-divider>
            <div>Peso Cotizar: </div>{{ peso_cobrar }}<v-divider vertical class="mx-2"></v-divider>
          </v-row>
        </v-card-text>
        <v-card elevation="10" outlined shaped v-if="isCliente == 0">
          <v-toolbar height="25px" dark color="#96298A">
            <v-toolbar-title>Tarifas a aplicar</v-toolbar-title>
          </v-toolbar>
          <v-card-text class="pt-0">
            <v-row>
                  <v-col>
                    <v-combobox
                      v-model="tarifaImport"
                      :items="tiposTarifa"
                      item-text="tipo"
                      item-value="codigo"
                      label="Tarifa Import"
                      prepend-icon="mdi-cash-lock"
                      return-object
                      clearable
                    ></v-combobox>
                  </v-col>
                  <v-col>
                    <v-combobox
                      v-model="tarifaExport"
                      :items="tiposTarifa"
                      item-text="tipo"
                      item-value="codigo"
                      label="Tarifa Export"
                      prepend-icon="mdi-cash-lock"
                      return-object
                      clearable
                    ></v-combobox>
                  </v-col>
                  <v-col>
                    <v-combobox
                    :disabled = "tarifaImport != null && tarifaImport.codigo == 'E'"
                      v-model="descuentoImport"
                      :items="tiposDescuento"
                      item-text="codigo"
                      item-value="id"
                      label="Descuento para Import"
                      prepend-icon="mdi-cash-lock"
                      return-object
                      clearable
                      persistent-hint
                      :hint="descuentoImport ? descuentoImport.porc_descuento + '%' : null"
                    ></v-combobox>
                  </v-col>
                  <v-col>
                    <v-combobox
                      :disabled = "tarifaExport != null && tarifaExport.codigo == 'E'"
                      v-model="descuentoExport"
                      :items="tiposDescuento"
                      item-text="codigo"
                      item-value="id"
                      label="Descuento para Export"
                      prepend-icon="mdi-cash-lock"
                      return-object
                      clearable
                      persistent-hint
                      :hint="descuentoExport ? descuentoExport.porc_descuento + '%' : null"
                    ></v-combobox>
                  </v-col>
                  <v-col>
                    <v-combobox
                      v-model="tramiteImport"
                      :items="tiposTramite"
                      item-text="tipo"
                      item-value="codigo"
                      label="Tramite Import"
                      prepend-icon="mdi-cash-lock"
                      return-object
                      clearable
                    ></v-combobox>
                  </v-col>
                </v-row>
          </v-card-text>
        </v-card>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-checkbox label="Deseo asegurar mi envio" v-model="seguro"></v-checkbox>
          <v-divider vertical class="mx-3"></v-divider>
          <v-btn dark color="#96298A" @click="cotizar()">Cotizar</v-btn>
        </v-card-actions>
      </v-card>
      <v-dialog
        v-model="dlgCotizacion"
        :fullscreen="fullScreen"
        width="900"
        transition="dialog-bottom-transition"
        scrollable
        persistent
      >
        <v-card elevation="24" outlined>
          <v-toolbar dark color="#96298A" dense max-height="50">
            <v-toolbar-title> Cotización </v-toolbar-title>
            <v-spacer />
            <v-toolbar-items>
              <v-divider vertical />
              <v-btn v-if="!fullScreen" icon dark @click="fullScreen = true">
                <v-icon>mdi-window-maximize</v-icon>
              </v-btn>
              <v-btn v-if="fullScreen" icon dark @click="fullScreen = false">
                <v-icon>mdi-window-minimize</v-icon>
              </v-btn>
              <v-divider vertical />
              <v-btn icon dark @click="cerrarModal()">
                <v-icon>mdi-close</v-icon>
              </v-btn>
              <v-divider vertical />
            </v-toolbar-items>
          </v-toolbar>
          <v-card-text>
            <cotizacion
              :dataGuia="dataGuia"
              v-if="dataGuia != null"
            ></cotizacion>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-row>
  </v-container>
</template>

<script>
import apicon from "../plugins/apicon";
import Cotizacion from "../components/Cotizacion.vue";
export default {
  name: "InxawbCotizar",
  components: {
    Cotizacion,
  },
  data() {
    return {
      isCliente: 1,
      dlgCotizacion: false,
      fullScreen: true,
      paises: [],
      paisRemitente: null,
      ciudad_e: null,
      pais_e: null,
      zip_e: null,
      paisDestino: null,
      ciudad_c: null,
      pais_c: null,
      zip_c: null,
      tipo: null,
      tipos: [{ tipo: "Documentos" }, { tipo: "No Documento" }],
      valor: 0,
      moneda: null,
      monedas: [],
      optUnidadPesoPaq: [
        { unidad_peso: "kgs", descripcion: "Kilogramos" },
        { unidad_peso: "lbs", descripcion: "Libras" },
      ],
      unidadPesoPaq: { unidad_peso: "kgs", descripcion: "Kilogramos" },
      optUMPaq: [
        { unidad_medida: "cm", descripcion: "Centimetros" },
        { unidad_medida: "in", descripcion: "Pulgadas" },
      ],
      uMPaq: { unidad_medida: "cm", descripcion: "Centimetros" },
      paquete: {
        piezas: 1,
        peso: null,
        unidad_peso: "kgs",
        // embalaje: null,
        largo: 0,
        ancho: 0,
        alto: 0,
        unidad_medida: "cm",
        pesototal: 0,
        volumentotal: 0,
        guia_interna: null,
      },
      paquetes: [],
      headersPaquetes: [
        { text: "Piezas", value: "piezas", align: "start" },
        { text: "Peso", value: "peso" },
        { text: "Unidad Peso", value: "unidad_peso" },
        { text: "Largo", value: "largo" },
        { text: "Ancho", value: "ancho" },
        { text: "Alto", value: "alto" },
        { text: "Unidad Medida", value: "unidad_medida" },
        { text: "Peso Total", value: "pesototal" },
        { text: "Volumen Total", value: "volumentotal" },
        { text: "Acciones", align: "end", value: "acciones", sortable: false },
      ],
      piezas: 0,
      peso: 0,
      volumen: 0,
      peso_cobrar: 0,
      dataGuia: null,
      seguro: false,
      tarifas:{
        tarifa_import: null,
        tarifa_export: null,
        descuento_import_id: null,
        descuento_export_id: null,
        tramite_import: null,
      },
      tarifaImport: null,
      tarifaExport: null,
      tramiteImport: null,
      tiposTarifa: [
        {codigo: 'P', tipo: 'Publica'},
        {codigo: 'E', tipo: 'Especial'},
      ],
      tiposTramite: [
        {codigo: 'P', tipo: 'Publico'},
        {codigo: 'E', tipo: 'Especial'},
      ],
      descuentoImport: null,
      descuentoExport: null,
      tiposDescuento: [],
    };
  },
  watch: {
    paisRemitente: function (item) {
      if (item) {
        this.pais_e = item.iso;
      }
    },
    paisDestino: function (item) {
      if (item) {
        this.pais_c = item.iso;
      }
    },
    tarifaImport: function(item){
      if(item){
        this.tarifas.tarifa_import = item.codigo
        if(item.codigo == 'E'){
          this.descuentoImport = null;
        }
      }else{
        this.tarifas.tarifa_import = null
      }
    },
    tarifaExport: function(item){
      if(item){
        this.tarifas.tarifa_export = item.codigo
        if(item.codigo == 'E'){
          this.descuentoExport = null;
        }
      }else{
        this.tarifas.tarifa_export = null
      }
    },
    tramiteImport: function(item){
      if(item){
        this.tarifas.tramite_import = item.codigo
      }else{
        this.tarifas.tramite_import = null
      }
    },
    descuentoImport: function(item){
      if(item){
        this.tarifas.descuento_import_id = item.id
      }else{
        this.tarifas.descuento_import_id = null
      }
    },
    descuentoExport: function(item){
      if(item){
        this.tarifas.descuento_export_id = item.id
      }else{
        this.tarifas.descuento_export_id = null
      }
    },
  },

  methods: {
    cotizar: async function () {
      let tipoguia = null;
      if (this.paisRemitente.iso == "EC" && this.paisDestino.iso != "EC") {
        tipoguia = "exportacion";
      } else if (
        this.paisDestino.iso == "EC" &&
        this.paisRemitente.iso != "EC"
      ) {
        tipoguia = "importacion";
      }
      if (tipoguia == null) {
        this.$swal(
          "No se puede solicitar este tipo de cotizacion, verificar Origen/Destino"
        );
        return;
      }
      var url = apicon.getApiBaseUrl() + "cotizarenvio";
      var datos = {
        pais_e: this.paisRemitente.iso,
        ciudad_e: this.ciudad_e,
        zip_e: this.zip_e,
        paisr: this.paisRemitente,
        pais_c: this.paisDestino.iso,
        ciudad_c: this.ciudad_c,
        zip_c: this.zip_c,
        paisc: this.paisDestino,
        paquetes: this.paquetes,
        piezas: this.piezas,
        peso: this.peso,
        volumen: this.volumen,
        peso_cobrar: this.peso_cobrar,
        tipoguia: tipoguia,
        valor: this.valor,
        moneda: this.moneda.moneda,
        tipo: this.tipo.tipo,
        created_at: new Date(),
        seguro: this.seguro ? 'SI' : 'NO',
        tarifas: this.tarifas
      };
      await apicon.saveDataApi(url, datos).then(async (result) => {
        this.dataGuia = await result;
        this.dlgCotizacion = true;
      });
    },
    cerrarModal: function () {
      this.dataGuia = null;
      this.dlgCotizacion = false;
    },
    fillPaises: async function () {
      var url = apicon.getApiBaseUrl() + "pais";
      await apicon.getDataApi(url).then((result) => {
        this.paises = result;
      });
    },
    fillMonedas: async function () {
      var url = apicon.getApiBaseUrl() + "moneda";
      await apicon.getDataApi(url).then((result) => {
        this.monedas = result;
        this.moneda = this.monedas.find((mo) => mo.moneda == 'USD');
      });
    },
    calcularPesoTotalPaquete: function () {
      this.paquete.pesototal =
        Math.round(this.paquete.piezas * this.paquete.peso * 100) / 100;
    },
    calcularVolumenTotalPaquete: function () {
      var dim = this.paquete.largo * this.paquete.ancho * this.paquete.alto;
      this.paquete.volumentotal =
        Math.round((dim / 5000) * this.paquete.piezas * 100) / 100;
    },
    calcularCostoTotalItem: function () {
      this.itemFac.total =
        Math.round(this.itemFac.cantidad * this.itemFac.costo * 100) / 100;
    },
    limpiarDatosPaquete: function () {
      this.paquete.piezas = 1;
      this.paquete.peso = null;
      this.paquete.unidad_peso = "kgs";
      this.paquete.largo = 0;
      this.paquete.ancho = 0;
      this.paquete.alto = 0;
      this.paquete.unidad_medida = "cm";
      this.paquete.pesototal = 0;
      this.paquete.volumentotal = 0;
      this.unidadPesoPaq = { unidad_peso: "kgs", descripcion: "Kilogramos" };
      this.uMPaq = { unidad_medida: "cm", descripcion: "Centimetros" };
      this.$refs.piezaspaquete.focus();
    },
    addPaquete: function (paquete) {
      // Crear una copia del paquete
      const paq = Object.assign({}, paquete);
      this.paquetes.push(paq);
      // Sumar las piezas en camposBD;
      this.limpiarDatosPaquete();
      this.totalizarPesosVolumen();
      //this.$refs.formPaquete.resetValidation();
    },
    deletePaquete: function (paquete) {
      // verificar si se esta editando()
      if (!this.editando) {
        this.paquetes.splice(
          this.paquetes.findIndex((p) => p === paquete),
          1
        );
        this.totalizarPesosVolumen();
      }
    },
    totalizarPesosVolumen: function () {
      this.piezas = this.paquetes.reduce(
        (sumPiezas, item) => sumPiezas + parseFloat(item.piezas),
        0
      );
      this.peso =
        Math.round(
          this.paquetes.reduce(
            (sumP, item) => sumP + parseFloat(item.pesototal),
            0
          ) * 100
        ) / 100;
      this.volumen =
        Math.round(
          this.paquetes.reduce(
            (sumV, item) => sumV + parseFloat(item.volumentotal),
            0
          ) * 100
        ) / 100;
      // Validar el peso a cobrar
      this.peso_cobrar = 0;
      this.paquetes.forEach((paq) => {
        if(paq.pesototal > paq.volumentotal){
          this.peso_cobrar += paq.pesototal;
        }else{
          this.peso_cobrar += paq.volumentotal;
        }
      })
      this.peso_cobrar = Math.round(this.peso_cobrar * 100) / 100;
      /*if (this.peso > this.volumen) {
        if (this.peso > (this.peso % 0.5 === 0 ? this.peso : Math.round(this.peso))) {
          this.peso_cobrar = Math.round(this.peso) + 0.5;
        } else {
          this.peso_cobrar = Math.round(this.peso);
        }
      } else {
        if (this.volumen > (this.volumen % 0.5 === 0 ? this.volumen : Math.round(this.volumen)) ) {
          this.peso_cobrar = Math.round(this.volumen) + 0.5;
        } else {
          this.peso_cobrar = Math.round(this.volumen);
        }
      }*/
    },
    fillTiposDescuento: async function(){
      await apicon.getDataApi(apicon.getApiBaseUrl() + 'coddescuento')
          .then((result) => {
            this.tiposDescuento = result;
          })
    },
  },

  mounted: async function () {
    await apicon.setAuthHeaders();
    await this.fillPaises();
    await this.fillMonedas();
    await this.fillTiposDescuento();
    this.isCliente = localStorage.getItem("cliente");
  },
};
</script>
